module.exports = __webpack_public_path__ + "static/media/t_nor_03.ed9e80e9.png";